import { resetStateRTK } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { GlobalState, CreateDictionaryLinksAndRegulations } from "../actions/globals/types";
import { defaultCurbLinkRecord } from "../interfaces/CurbLink";
import { defaultCurbRegulationRecord } from "../interfaces/CurbRegulation";
import { createReducer } from "@reduxjs/toolkit";
import {
    currentApplicationVersion,
    setIsGeoserverEnabled,
    storeCurbLinks,
    storeCurbRegulations,
    storeDictionaryCurbLinksAndRegulations,
    storeGeoserverCurbRegulations
} from "actions";

const initialState: GlobalState = {
    dictionaryCurbLinks: { "-1": defaultCurbLinkRecord },
    dictionaryCurbRegulations: defaultCurbRegulationRecord,
    dictionaryLinksAndRegulations: {} as CreateDictionaryLinksAndRegulations,
    isGeoserverEnabled: false,
    currentApplicationVersion: "",
    geoserverCurbRegulations: {}
};

const globals = createReducer(initialState, (builder) => {
    builder
        .addCase(storeCurbLinks, (state, action) => {
            state.dictionaryCurbLinks = action.payload.curbLinks;
        })
        .addCase(storeCurbRegulations, (state, action) => {
            state.dictionaryCurbRegulations = action.payload.curbRegulations;
        })
        .addCase(setIsGeoserverEnabled, (state, action) => {
            state.isGeoserverEnabled = action.payload.isGeoserverEnabled;
        })
        .addCase(storeDictionaryCurbLinksAndRegulations, (state, action) => {
            state.dictionaryLinksAndRegulations = action.payload.dictionaryLinksAndRegulations;
        })
        .addCase(resetStateRTK, () => initialState)
        .addCase(currentApplicationVersion, (state, action) => {
            state.currentApplicationVersion = action.payload.currentApplicationVersion;
        })
        .addCase(storeGeoserverCurbRegulations, (state, action) => {
            state.geoserverCurbRegulations = action.payload.curbRegulations;
        })
        .addDefaultCase((state) => state);
});

export default globals;
